import React from 'react';
import './styles/app.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';

import AppRoutes from './routes/AppRoutes';
import { DARK_MODE, LIGHT_MODE } from './generalUtils/themeClasses';
import WebPushNotificationContainer from './hoc/WebPushNotificationContainer';
// import { appConf } from './appConf';

const App = ({ themeArr = {} }) => {
  const { isLightTheme } = themeArr;

  // useEffect(() => {
  //   let photonScript = document.getElementById('dipPhoton360CommonScript');
  //   const src = `${appConf.assets_url}v4/photon360script.js`;
  //   if (photonScript) {
  //     photonScript.remove();
  //     photonScript = null;
  //   }
  //   if (!photonScript) {
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = src;
  //     script.id = 'dipPhoton360CommonScript';
  //     script.async = true;
  //     script.onload = () => {
  //       console.log('Photon script loaded');

  //       if (window.DIP && window.DIP.Photon360VDP) {
  //         console.log('Photon360VDP ready');
  //       }
  //     };
  //     document.body.appendChild(script);
  //   }
  // }, []);
  return (
    <>
      <AppRoutes />
      <ToastContainer
        style={{ zIndex: '1000000001' }}
        position="top-right"
        autoClose={5000}
        // hideProgressBar={true}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
        theme={isLightTheme ? LIGHT_MODE : DARK_MODE}
      />
      <WebPushNotificationContainer />
    </>
  );
};

const mapStateToProps = state => ({
  themeArr: state?.mainlayout?.themeArr
});
App.displayName = 'App';
export default connect(mapStateToProps)(App);
